<template>
  <div class="dashboard-sample" style="display:flex">
    <div>
      <div>
        <el-select @change="sampleChange" v-model="sampletype" placeholder="请选择图标类型">
          <el-option 
            label="1、年度预算分配、年度预算计划"
            value="1">
          </el-option>
          <el-option
            label="2、预算计划与执行进度"
            value="2">
          </el-option>
          <el-option
            label="3、预算计划与执行季度趋势"
            value="3">
          </el-option>
          <el-option
            label="4、预算计划与执行月度趋势"
            value="4">
          </el-option>
          <el-option
            label="5、策略计划占比"
            value="5">
          </el-option>
          <el-option
            label="6、策略执行进度、会议执行进度"
            value="6">
          </el-option>
          <el-option
            label="7、策略月度趋势"
            value="7">
          </el-option>
          <el-option
            label="8、会议计划占比"
            value="8">
          </el-option>
          <el-option
            label="9、评分"
            value="9">
          </el-option>
        </el-select>
      </div>
      <div style="margin-top:10px">
        <el-input
          type="textarea"
          :rows="30"
          v-model="sampledata"
          placeholder="选择图标类型后，会在这里显示对应的数据，修改数据后点击应用可以实时更新图表"
        >
        </el-input>
      </div>
      <div style="margin-top:10px; float:right">        
        <el-button type="primary" @click="setSample">应用</el-button>
      </div>
    </div>
    <div style="margin-left:20px"> 
      <el-row>
        <el-col :span="8">        
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['已分配预算']"  
            :dataset-source="data1"
            :option="option1"
            ref="sample1"
          >    
          </common-echars>
        </el-col>
        <el-col :span="8">        
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['进度','已计划预算','已执行预算','待执行预算','计划外预算']"  
            :dataset-source="data2"
            :option="option2"
            ref="sample2"
          >    
          </common-echars>
        </el-col>
        <el-col :span="8">        
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['季度','已计划','已执行','待执行','计划外','已分配预算']"  
            :dataset-source="data3"
            :option="option3"
            ref="sample3"
          >    
          </common-echars>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="8">        
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['月度','已计划','已执行','待执行','计划外']"  
            :dataset-source="data4"
            :option="option4"
            ref="sample4"
          >    
          </common-echars>
        </el-col>
        <el-col :span="8">       
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['策略名','占比']"  
            :dataset-source="data5"
            :option="option5"
            ref="sample5"
          >    
          </common-echars>  
        </el-col>
        <el-col :span="8">         
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['策略名','已执行','待执行','计划外','已计划']"  
            :dataset-source="data6"
            :option="option6"
            ref="sample6"
          >    
          </common-echars> 
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="8">        
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="dimensions7"  
            :dataset-source="source7"
            :option="option7"
            ref="sample7"
          >    
          </common-echars>
        </el-col>
        <el-col :span="8">          
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['类型','占比']"  
            :dataset-source="data8"
            :option="option8"
            ref="sample8"
          >    
          </common-echars> 
        </el-col>
        <el-col :span="8">          
          <common-echars
            chartClass="chart-class"
            :dataset-dimensions="['预算','评分']"  
            :dataset-source="data9"
            :option="option9"
            ref="sample9"
          >    
          </common-echars> 
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// import CommonEchars from '../../../common/CommonEchars.vue';
export default {
  // components: { CommonEchars },
  data () {
      return {
        sampledata:'',
        sampletype:'',
        //1、年度预算分配、年度预算计划
        data1: [{
          '已分配预算':'70',
        },],
        option1: {
            title: { text: '1、年度预算分配、年度预算计划' },
            tooltip: { trigger: 'item' },
            series: [
              {
                type: 'gauge',
                progress: {
                  show: true,
                  width: 18
                },
                axisLine: {
                  lineStyle: {
                    width: 18
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  length: 15,
                  lineStyle: {
                    width: 2,
                    color: '#999'
                  }
                },
                axisLabel: {
                  distance: 25,
                  color: '#999',
                  fontSize: 14
                },
                anchor: {
                  show: true,
                  showAbove: true,
                  size: 14,
                  itemStyle: {
                    borderWidth: 10
                  }
                },
                title: {
                  show: false
                },
                detail: {
                  valueAnimation: true,
                  fontSize: 24,
                  offsetCenter: [0, '70%']
                },
              }
            ]
        },     
        //2、预算计划与执行进度
        data2: [
          {
            '进度':'进度',
            '已计划预算': 600,
            '已执行预算': 250,
            '待执行预算': 350,
            '计划外预算': 30
          },
        ],
        option2: {          
          title: { text: '2、预算计划与执行进度' },
          tooltip: { trigger: 'item' },
          xAxis: {},
          yAxis: {type: 'category'},
          series: [
            {type:'bar'},
            {type:'bar',stack:'detail'},            
            {type:'bar',stack:'detail'},
            {type:'bar',stack:'detail'},
          ]
        },              
        //3、预算计划与执行季度趋势
        data3: [
          {
            '季度':'第一季度',
            '已计划': 380,
            '已执行': 400,
            '待执行': 15,
            '计划外': 5,
            '已分配预算': 400
          },
          {
            '季度':'第二季度',
            '已计划': 420,
            '已执行': 300,
            '待执行': 60,
            '计划外': 30,
            '已分配预算': 420
          },
          {
            '季度':'第三季度',
            '已计划': 310,
            '已执行': 200,
            '待执行': 0,
            '计划外': 30,
            '已分配预算': 300
          },
          {
            '季度':'第四季度',
            '已计划': 330,
            '已执行': 330,
            '待执行': 0,
            '计划外': 0,
            '已分配预算': 330
          },
        ],
        option3: {          
          title: { text: '3、预算计划与执行季度趋势' },
          tooltip: { trigger: 'item' },
          xAxis: {type: 'category'},
          yAxis: {},
          series: [
            {type:'bar'},
            {type:'bar',stack:'detail'},            
            {type:'bar',stack:'detail'},
            {type:'bar',stack:'detail'},
            {type:'line'},
          ]
        },                            
        //4、预算计划与执行月度趋势
        data4: [
          {
            '月度':'一月',
            '已计划': 58,
            '已执行': 33,
            '待执行': 15,
            '计划外': 10,
          },
          {
            '月度':'二月',
            '已计划': 75,
            '已执行': 42,
            '待执行': 20,
            '计划外': 13,
          },
          {
            '月度':'三月',
            '已计划': 50,
            '已执行': 34,
            '待执行': 6,
            '计划外': 10,
          },
          {
            '月度':'四月',
            '已计划': 74,
            '已执行': 46,
            '待执行': 15,
            '计划外': 13,
          },          
          {
            '月度':'五月',
            '已计划': 64,
          },       
          {
            '月度':'六月',
            '已计划': 55,
          },       
          {
            '月度':'七月',
            '已计划': 64,
          },       
          {
            '月度':'八月',
            '已计划': 51,
          },       
          {
            '月度':'九月',
            '已计划': 71,
          },       
          {
            '月度':'十月',
            '已计划': 55,
          },       
          {
            '月度':'十一月',
            '已计划': 71,
          },       
          {
            '月度':'十二月',
            '已计划': 48,
          },
        ],
        option4: {      
          legend: {
            data: ['已计划', '已执行', '待执行','计划外']
          },    
          title: { text: '4、预算计划与执行月度趋势' },
          tooltip: { trigger: 'item' },
          xAxis: {type: 'category'},
          yAxis: {},
          series: [
            {type:'line'},
            {type:'bar',stack:'detail'},            
            {type:'bar',stack:'detail'},
            {type:'bar',stack:'detail'},
          ]
        }, 
        //5、策略计划占比
        data5: [
          {
            '策略名':'策略一',
            '占比': 98,
          },
          {
            '策略名':'策略二',
            '占比': 90,
          },
          {
            '策略名':'策略三',
            '占比': 75,
          },
          {
            '策略名':'新策略',
            '占比': 83,
          }
        ],
        option5: {          
          title: { text: '5、策略计划占比' },
          tooltip: { trigger: 'item' },
          polar: {
            radius: [30, '80%']
          },
          angleAxis: {
          },
          radiusAxis: {
            type: 'category',
          },
          series: {
            type: 'bar',
            coordinateSystem: 'polar',
          }
        },
        //6、策略执行进度、会议执行进度
        data6: [
          {
            '策略名':'策略一',
            '已计划': 98,
            '已执行': 55,
            '待执行': 45,
            '计划外': 8,
          },
          {
            '策略名':'策略二',
            '已计划': 90,
            '已执行': 38,
            '待执行': 63,
            '计划外': 10,
          },
          {
            '策略名':'策略三',
            '已计划': 75,
            '已执行': 42,
            '待执行': 33,
            '计划外': 0,
          },
          {
            '策略名':'新策略',
            '已计划': 83,
            '已执行': 38,
            '待执行': 47,
            '计划外': 0,
          }
        ],
        option6: {          
          title: { text: '6、策略执行进度、会议执行进度' },
          tooltip: { trigger: 'item' },           
          xAxis: {},
          yAxis: {type: 'category'},
          series: [
            {type:'bar',stack:'detail'},            
            {type:'bar',stack:'detail'},
            {type:'bar',stack:'detail'},
            {type:'bar'},
          ]
        },
        //7、策略月度趋势
        data7: {
            "strategyNames": [
                "策略一",
                "策略二",
                "策略三"
            ],
            "data": [
                {
                    "月度": "一月",
                    "策略一": 98,
                    "策略二": 55
                },
                {
                    "月度": "二月",
                    "策略一": 103,
                    "策略二": 42
                },
                {
                    "月度": "三月",
                    "策略一": 75,
                    "策略二": 63
                },
                {
                    "月度": "四月",
                    "策略一": 66,
                    "策略二": 78,
                    "策略三": 48
                },
                {
                    "月度": "五月",
                    "策略一": 80,
                    "策略二": 62,
                    "策略三": 73
                },
                {
                    "月度": "六月",
                    "策略一": 93,
                    "策略二": 91,
                    "策略三": 79
                },
                {
                    "月度": "七月",
                    "策略一": 73,
                    "策略二": 80,
                    "策略三": 93
                },
                {
                    "月度": "八月",
                    "策略一": 65,
                    "策略三": 91
                },
                {
                    "月度": "九月",
                    "策略一": 55,
                    "策略三": 80
                },
                {
                    "月度": "十月",
                    "策略一": 84,
                    "策略三": 86
                },
                {
                    "月度": "十一月",
                    "策略一": 100,
                    "策略三": 80
                },
                {
                    "月度": "十二月",
                    "策略一": 120,
                    "策略三": 87
                }
            ]
        },
        option7: {          
          title: { text: '7、策略月度趋势' },
          tooltip: { 
            trigger: 'item',
            formatter: (params) => {
              let info = '';
              for (const key in params.value) {
                if (Object.hasOwnProperty.call(params.value, key)) {
                  if(key != '月度') {
                    info += key + '：' + params.value[key] + '<br\>';
                  }
                  
                }
              }

              return info;
            }
          },           
          xAxis: {type: 'category'},
          yAxis: {},
          series: []
        },
        //8、会议计划占比
        data8: [
          {
            '类型': '线上会',
            '占比': 1000,
          },
          {
            '类型': '线下会',
            '占比': 900,
          },
          {
            '类型': '线上+线下会',
            '占比': 750,
          },
        ],
        option8: {          
          title: { text: '8、会议计划占比' },
          tooltip: { trigger: 'item' }, 
          series: [
            {type:'pie'},
          ]
        },
        //9、评分
        data9: [
          {
            '预算合评分': '150+6',
            '预算': 150,
            '评分': 6,
            '会议名称': 'XXX1',
            '活动负责人': 'YYY1',
            '策略重点': 'aaa1',
            '会议形式': 'bbb1',
            '会议类型': 'ccc1',
          },
          {
            '预算合评分': '150+6',
            '预算': 150,
            '评分': 6,
            '会议名称': 'XXX2',
            '活动负责人': 'YYY2',
            '策略重点': 'aaa2',
            '会议形式': 'bbb2',
            '会议类型': 'ccc2',
          },
          {
            '预算合评分': '200+7',
            '预算': 200,
            '评分': 7,
            '会议名称': 'XXX3',
            '活动负责人': 'YYY3',
            '策略重点': 'aaa3',
            '会议形式': 'bbb3',
            '会议类型': 'ccc3',
          },
          {
            '预算合评分': '100+3',
            '预算': 100,
            '评分': 3,
            '会议名称': 'XXX4',
            '活动负责人': 'YYY4',
            '策略重点': 'aaa4',
            '会议形式': 'bbb4',
            '会议类型': 'ccc4',
          },
          {
            '预算合评分': '200+10',
            '预算': 200,
            '评分': 10,
            '会议名称': 'XXX5',
            '活动负责人': 'YYY5',
            '策略重点': 'aaa5',
            '会议形式': 'bbb5',
            '会议类型': 'ccc5',
          },
        ],
        option9: {          
          title: { text: '9、评分' },
          tooltip: { 
            trigger: 'item',
            formatter: (params) => {
              let budgetScore = params.value['预算合评分'];

              let info = '';
              for (const data of this.data9) {
                if(data['预算合评分'] == budgetScore) {
                  info += info? '<br/><br/>' : '';
                  info += `评分：${data['评分']}<br\>'`;
                  info += `预算：${data['预算']}K<br\>'`;
                  info += `会议名称：${data['会议名称']}<br\>'`;
                  info += `活动负责人：${data['活动负责人']}<br\>'`;
                  info += `策略重点：${data['策略重点']}<br\>'`;
                  info += `会议形式：${data['会议形式']}<br\>'`;
                  info += `会议类型：${data['会议类型']}'`;
                }
              }
              
              return info;
            }
          }, 
          xAxis: {},
          yAxis: {},
          series: [
            {type:'scatter',symbolSize: 20,},
          ]
        },
      }
    },
    computed: {
      dimensions7() {
        this.option7.series = [];
        for (let index = 0; index < this.data7.strategyNames.length; index++) {
          this.option7.series.push({type:'line'})
        }
        let dimensions = _.clone(this.data7.strategyNames);
        dimensions.unshift('月度');
        return dimensions;
      },
      source7() {
        return this.data7.data;
      }
    },
    methods: {
      sampleChange(){
          this.sampledata = JSON.stringify(this['data'+this.sampletype], null, 4);
      },
      setSample() {
          this['data'+this.sampletype] = JSON.parse(this.sampledata);
          this.$nextTick(() => this.$refs['sample'+this.sampletype].chartChange());
      },
  }
};
</script>

<style lang="less">
  .dashboard-sample {    
    .chart-class {
        width: 300px;
        height: 300px;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?55c9fb61